<template>
  <div class="card">
    <div class="card-header pb-0 mb-2">
      <h6>Members table (Active user : {{ active_users }}) </h6>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <vue-good-table
          :columns="columns"
          :rows="rows"
          :pagination-options="{
            enabled: true,
            mode: 'records',
          }"
          :search-options="{ enabled: true }"
          :line-numbers="true"
          :isLoading="isLoading"
        >
          <template #table-row="props">
            <span v-if="props.column.field == 'line_display'">
              <router-link :to="{ name: 'user/detail', params: { username: props.row.username } }">{{
                (props.row.line_display) ? props.row.line_display : 'ไม่มีบันทึกข้อมูล'
              }}</router-link>
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
// import moment from 'moment';
// import moment from "moment";
export default {
  name: "Datatable-members",
  props: {
    //   users: {
    //     type: Array,
    //     default: () => [],
    //   },
    rows: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    active_users() {
      return this.rows.filter((user) => {
        return user.remaining_day > 0;
        // return moment(user.expired_day).diff(moment(), 'days') > 0;
      }).length;
    },
  },
};
</script>
